// Navbar.jsx
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import DesktopMenu from './DesktopMenu';
import MobileMenu from './MobileMenu';
import salientLogo from '../../assets/images/logos/salient_logo.png';

const Navbar = () => {
  const [isMenuOpen, setMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  
  // Toggle menu function
  const toggleMenu = () => setMenuOpen(!isMenuOpen);
  
  // Handle scroll event for navbar appearance
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  
  // Define menu items with their submenus
  const menuItems = [
    {
      label: 'Inicio',
      path: '/'
    },
    // {
    //   label: 'Tecnología',
    //   path: '/tech',
    //   // submenu: [
    //   //   {
    //   //     label: 'Infraestructura de red',
    //   //     path: '/tech/network-infrastructure'
    //   //   },
    //   //   {
    //   //     label: 'Consultoría en software',
    //   //     path: '/tech/software-consulting'
    //   //   },
    //   // ]
    // },
    // {
    //   label: 'Soluciones Empresariales',
    //   path: '/solutions',
    //   // submenu: [
    //   //   {
    //   //     label: 'Marketing digital',
    //   //     path: '/mkt/digital-marketing'
    //   //   },
    //   //   {
    //   //     label: 'Ventas',
    //   //     path: '/mkt/sales'
    //   //   },
    //   // ]
    // },
    // {
    //   label: 'Energía',
    //   submenu: [
    //     {
    //       label: 'Energías limpias',
    //       path: '/energy/clean-energy'
    //     },
    //     {
    //       label: 'Proyectos eléctricos',
    //       path: '/energy/electrical-projects'
    //     },
    //   ]
    // },
    {
      label: 'Quienes somos',
      path: '/about-us',
    },
    {
      label: 'Contáctanos',
      path: '/contact'
    },
  ];

  return (
    <nav 
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 bg-salient-primary ${
        isScrolled 
          ? 'backdrop-blur-sm shadow-lg py-4' 
          : 'py-6'
      }`}
    >
      <div className="container mx-auto px-4 lg:px-8">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <Link 
            to="/" 
            className="flex items-center" 
            aria-label="Salient Homepage"
          >
            <div className="text-2xl font-bold relative">
              {/* <span className="relative z-10 transition-all duration-300 bg-clip-text text-white hover:to-blue-500">
                SALIENT
              </span> 
              <span className="absolute -bottom-1 left-0 w-full h-1 bg-gradient-to-r from-blue-500 to-green-400 opacity-70 rounded-full"></span>
              */}
              <img src={salientLogo} alt="Salient Logo" className={`h-auto transition-all duration-300 ${isScrolled ? 'w-32' : 'w-48'}`}/>              
            </div>
          </Link>

          {/* Menu Burger */}
          <div className="lg:hidden">
            <button 
              onClick={toggleMenu} 
              className="flex items-center p-2 rounded-md hover:bg-gray-100 transition-colors duration-300"
              aria-expanded={isMenuOpen}
              aria-label="Toggle navigation menu"
            >
              <div className="relative w-6 h-5">
                <span 
                  className={`absolute h-0.5 w-6 bg-gray-800 transform transition-all duration-300 rounded-full ${
                    isMenuOpen ? 'rotate-45 top-2' : 'top-0'
                  }`}
                ></span>
                <span 
                  className={`absolute h-0.5 w-6 bg-gray-800 top-2 transition-all duration-300 rounded-full ${
                    isMenuOpen ? 'opacity-0' : 'opacity-100'
                  }`}
                ></span>
                <span 
                  className={`absolute h-0.5 w-6 bg-gray-800 transform transition-all duration-300 rounded-full ${
                    isMenuOpen ? '-rotate-45 top-2' : 'top-4'
                  }`}
                ></span>
              </div>
            </button>
          </div>

          {/* Desktop Menu */}
          <div className="hidden lg:block">
            <DesktopMenu menuItems={menuItems} isScrolled={isScrolled} />
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      <MobileMenu 
        isOpen={isMenuOpen} 
        menuItems={menuItems} 
        toggleMenu={toggleMenu}
      />
    </nav>
  );
};

export default Navbar;